import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=44d2ecb2"
import script from "./NotificationDetail.vue?vue&type=script&lang=js"
export * from "./NotificationDetail.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=44d2ecb2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports